const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_workspace.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';

/** Chromeless authenticated shell for focused, full-viewport workflows. */
export const Route = createFileRoute('/_authenticated/_workspace')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});